module.exports = __webpack_public_path__ + "img/image 49.9f905144.svg";